export default "__VITE_ASSET__SYRz09U9__"